export enum TransactionTypes {
  B2B_HV = 7,
  B2C_HV = 8,
  B2C_HV_BEGATE = 9,
  B2B2C_HV = 10,
  B2B_MULTIPLE = 11,
}
